// extracted by mini-css-extract-plugin
module.exports = {"prevInnerContent":"styles_prevInnerContent__6fg75","overlay":"styles_overlay__KhfWK"};